import { OdinPay } from "./OdinPay";

window.OdinPay = OdinPay;

export default OdinPay;
